<div class="activities-container">
  <!-- Tabs: Assets | Compute (optional) | User action (when showTabs is true) -->
  <div class="activities__tabs-row" *ngIf="showTabs">
    <div class="activities__tabs">
      <button
        type="button"
        class="activities__tab"
        [class.activities__tab--active]="activeLogType === 'ASSET'"
        (click)="setLogType('ASSET')"
      >
        Assets
      </button>
      <button
        *ngIf="!hideComputeTab"
        type="button"
        class="activities__tab"
        [class.activities__tab--active]="activeLogType === 'COMPUTE'"
        (click)="setLogType('COMPUTE')"
      >
        Compute
      </button>
      <button
        type="button"
        class="activities__tab"
        [class.activities__tab--active]="activeLogType === 'USER_ACTION'"
        (click)="setLogType('USER_ACTION')"
      >
        User action
      </button>
    </div>
  </div>

  <!-- Filter Section (Compute tab: no Asset Type, Activity options = start/delete/open/create/stop only) -->
  <app-filter-panel
    *ngIf="showFilters"
    [fields]="effectiveFilterFields"
    [defaultExpanded]="false"
    (filterChange)="onFilterChange($event)"
    (clearFilters)="onClearFilters()"
  ></app-filter-panel>

  <!-- Table -->
  <app-table
    [columns]="columns"
    [data]="activitiesData"
    [scrollHeight]="'400px'"
    [loading]="loading"
    [pagination]="pagination"
    [emptyMessage]="emptyMessage"
    [striped]="true"
    [bordered]="true"
    [hoverable]="true"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    (sortChange)="onSortChange($event)"
  >
    <!-- Custom Activity Column with Left Border Accent -->
    <ng-template #activityCell let-row>
      <div class="activity-cell" [ngClass]="getActivityClass(row.activity)">
        <span class="activity-text" [attr.title]="row.activity">{{ row.activity }}</span>
      </div>
    </ng-template>
  </app-table>
</div>
